"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default() {
  var ready, error;
  var pending = new Promise(function (resolve, reject) {
    ready = resolve;
    error = reject;
  });
  return [pending, ready, error];
};

exports.default = _default;
//# sourceMappingURL=pendingFactory.js.map